import Vue from 'vue'
import App from './App.vue'
import router from './router'
import mandMobile from 'mand-mobile'
import 'mand-mobile/lib/mand-mobile.css'

Vue.use(mandMobile)

Vue.config.productionTip = false

// 设置统一的headers
Vue.prototype.$headers = {
  'Access-Control-Allow-Origin': '*',
  "Content-Type": "multipart/form-data"
}

Vue.prototype.$version = '20230111-1';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
